import { render, staticRenderFns } from "./NewOrderItemForm.vue?vue&type=template&id=5ca2f22b&scoped=true&"
import script from "./NewOrderItemForm.vue?vue&type=script&lang=js&"
export * from "./NewOrderItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca2f22b",
  null
  
)

export default component.exports